import { Component, Input } from '@angular/core';

import { remessa } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-remessa',
    templateUrl: './config-pedido-tipo-venda-badge-remessa.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-remessa.component.less']
})
export class ConfigPedidoTipoVendaBadgeRemessaComponent {
    tipo = remessa;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
